import { ok } from './Ok.js';
import { err } from './Err.js';
export const okIf = (value, predicate, fallback) => predicate(value)
    ? ok(value)
    : err(typeof fallback === 'function' ? fallback(value) : fallback);
export const expect = (predicate, fallback) => (value) => okIf(value, predicate, fallback);
export const expectExists = (fallback) => (value) => okIf(value, (value) => value != null, fallback);
export const okIfExists = (value, fallback) => okIf(value, (value) => value != null, fallback);
